import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4b8f4a46"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "container"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content"
}, [/*#__PURE__*/_createElementVNode("h2", null, "用户之间纠纷处理方式"), /*#__PURE__*/_createTextVNode(" ①我公司平台仅作为平台的运营商，如若本站用户之间发生纠纷且无法协商一致的，可向国家相关行政机关或司法机关寻求解决包括但不限于向公安机关报案、申请仲裁或向人民法院提起诉讼等。公司将会为实名注册用户提供必要的协助和支持，并根据有关行政机关和司法机关的要求承担一定的举证责任或采取必要措施。 "), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode("②本网站用户之间发生纠纷的，也可向我们公司的客服人员投诉并举证。用户需提供与其账号注册信息一致的个人有效身份证件、必要的国家行政或司法机关文件和其他公司要求提供的相关证据。经公司审核确认后，可以给予必要的协助和支持。 "), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode("用户与公司之间纠纷处理方式 "), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode("①如本网站用户对我公司网站的服务有任何异议的，可以向公司的客服人员投诉并举证。查证属实的，公司将立即更正并按照现行法律规定给予用户必要的补偿。 "), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode("②如本站用户对公司的服务有任何异议的，也可以向双方约定的公司所在地人民法院提起诉讼。 ")], -1));
import NavBread from "@/components/bread.vue";
import { onMounted, reactive } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const data = reactive({
      title: '纠纷处理'
    });
    onMounted(() => {
      window.scrollTo(0, 0);
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(NavBread, {
        title: data.title
      }, null, 8, ["title"]), _hoisted_2]);
    };
  }
});